import { render, staticRenderFns } from "./CustomerGroupDataTableRow.vue?vue&type=template&id=77cfb6f1&"
import script from "./CustomerGroupDataTableRow.vue?vue&type=script&lang=js&"
export * from "./CustomerGroupDataTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports